import React, { useState, useLayoutEffect } from 'react';
import { useIsSsr } from 'utils/hooks';

const Lottie = React.lazy(() => import('react-lottie-player'));

// documentation https://github.com/mifi/react-lottie-player

const Animation = ({ name, path, preserveAspectRatio, className, ...props }) => {
  const [animationData, setAnimationData] = useState();
  const isSsr = useIsSsr();

  useLayoutEffect(() => {
    if (name && !isSsr) {
      const animation = require(`lottieFiles/${name}.json`);
      setAnimationData(animation);
    }
  }, [name, isSsr]);

  if (isSsr) {
    return <div className={className} style={{ height: '100%', width: '100%' }} />;
  }

  const defaultStyle = {
    height: '100%',
    width: '100%',
  };

  const options = {
    loop: true,
    play: true,
    style: defaultStyle,
    ...props,
  };

  if (preserveAspectRatio) {
    options.rendererSettings = { preserveAspectRatio: 'xMidYMid slice' };
  }

  return (
    <div className={className}>
      <React.Suspense fallback={<div style={defaultStyle} />}>
        {path && <Lottie path={path} {...options} />}
        {!path && animationData && <Lottie animationData={animationData} {...options} />}
      </React.Suspense>
    </div>
  );
};

export default Animation;
